export type AgendaViewMode = 'day' | 'week';

export const agendaDateKey = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}-${String(date.getDate()).padStart(2, '0')}`;
};

export const getAgendaWeekdays = (selectedDate: Date) => {
  const monday = new Date(selectedDate);
  monday.setHours(0, 0, 0, 0);
  monday.setDate(monday.getDate() - (monday.getDay() + 6) % 7);
  return Array.from({ length: 5 }, (_, index) => {
    const date = new Date(monday);
    date.setDate(date.getDate() + index);
    return date;
  });
};

// Split only appointments that actually overlap; every appointment stays callable.
export const arrangeAgendaAppointments = <T extends { top: number; height: number }>(appointments: readonly T[]) => {
  const result: Array<T & { lane: number; laneCount: number }> = [];
  let cluster: Array<T & { lane: number }> = [];
  let laneEnds: number[] = [];
  let clusterEnd = -Infinity;
  const flush = () => {
    result.push(...cluster.map((appointment) => ({ ...appointment, laneCount: laneEnds.length })));
    cluster = [];
    laneEnds = [];
    clusterEnd = -Infinity;
  };
  for (const appointment of [...appointments].sort((a, b) => a.top - b.top || b.height - a.height)) {
    if (appointment.top >= clusterEnd - 1e-8) flush();
    let lane = laneEnds.findIndex((end) => end <= appointment.top + 1e-8);
    if (lane < 0) lane = laneEnds.length;
    const end = appointment.top + appointment.height;
    laneEnds[lane] = end;
    clusterEnd = Math.max(clusterEnd, end);
    cluster.push({ ...appointment, lane });
  }
  flush();
  return result;
};
